<template>
  <div>
    <div id="aboutPanel" class="grid-side-space tabcontent">
      <div class="content">

        <h4 class="blueTitle">{{ $t("terms.title1") }}</h4><br>
        <h4>{{ $t("terms.title1_subtitle1") }}</h4>
        <p>{{ $t("terms.title1_text1") }}</p>

        <h4>{{ $t("terms.title1_subtitle2") }}</h4>
        <p>{{ $t("terms.title1_text2") }}</p>
        <h4>{{ $t("terms.title1_subtitle3") }}</h4>
        <p>{{ $t("terms.title1_text3") }}</p>
        <br><br>
        <h4 class="blueTitle">{{ $t("terms.title2") }}</h4><br>
        <h4>{{ $t("terms.title2_subtitle1") }}</h4>
        <p>{{ $t("terms.title2_text1") }}</p>
        <p>{{ $t("terms.title2_text1_2") }}</p>

        <h4>{{ $t("terms.title2_subtitle2") }}</h4>
        <p>{{ $t("terms.title2_text2") }}</p>
        <p>{{ $t("terms.title2_text2_2") }}</p>
        <p>{{ $t("terms.title2_text2_3") }}</p>
        <ul class="list">
          <li>{{ $t("terms.registration_data1") }}</li>
          <li>{{ $t("terms.registration_data2") }}</li>
          <li>{{ $t("terms.registration_data3") }}</li>
          <li>{{ $t("terms.registration_data4") }}</li>
          <li>{{ $t("terms.registration_data5") }}</li>
          <li>{{ $t("terms.registration_data6") }}</li>
          <li>{{ $t("terms.registration_data7") }}</li>
          <li>{{ $t("terms.registration_data8") }}</li>
        </ul>
        <p>{{ $t("terms.title2_text2_4") }}</p>


        <h4>{{ $t("terms.title2_subtitle3") }}</h4>
        <p>{{ $t("terms.title2_text3_1") }}</p>

        <h4>{{ $t("terms.title2_subtitle4") }}</h4>
        <p>{{ $t("terms.title2_text4_1") }}</p>
        <p>{{ $t("terms.title2_text4_2") }}</p>
        <ul class="list">
          <li>{{ $t("terms.title2_deleteAccunt2") }}</li>
          <li>{{ $t("terms.title2_deleteAccunt3") }}</li>
          <li>{{ $t("terms.title2_deleteAccunt4") }}</li>
          <li>{{ $t("terms.title2_deleteAccunt5") }}</li>
          <li>{{ $t("terms.title2_deleteAccunt6") }}</li>
          <li>{{ $t("terms.title2_deleteAccunt7") }}</li>
          <li>{{ $t("terms.title2_deleteAccunt8") }}</li>
          <li>{{ $t("terms.title2_deleteAccunt9") }}</li>
        </ul>

        <h4>{{ $t("terms.title2_subtitle5") }}</h4>
        <p>{{ $t("terms.title2_text5_1") }}</p>
        <p>{{ $t("terms.title2_text5_2") }}</p>
        <p>{{ $t("terms.title2_text5_3") }}</p>
        <p>{{ $t("terms.title2_text5_4") }}</p>
        <p>{{ $t("terms.title2_text5_5") }}</p>

        <h4>{{ $t("terms.title2_subtitle6") }}</h4>
        <p>{{ $t("terms.title2_text6_1") }}</p>

        <br><br>
        <h4 class="blueTitle">{{ $t("terms.title3") }}</h4><br>
        <h4>{{ $t("terms.title3_subtitle1") }}</h4>
        <p>{{ $t("terms.title3_text1_1") }}</p>
        <p>{{ $t("terms.title3_text1_2") }}</p>

        <br><br>
        <h4 class="blueTitle">{{ $t("terms.title4") }}</h4><br>
        <h4>{{ $t("terms.title4_subtitle1") }}</h4>
        <p>{{ $t("terms.title4_text1_1") }}</p>
        <p>{{ $t("terms.title4_text1_2") }}</p>
        <p>{{ $t("terms.title4_text1_3") }}</p>
        <p>{{ $t("terms.title4_text1_4") }}</p>

        <h4>{{ $t("terms.title4_subtitle2") }}</h4>
        <p>{{ $t("terms.title4_text2_1") }}</p>

        <h4>{{ $t("terms.title4_subtitle3") }}</h4>
        <p>{{ $t("terms.title4_text3_1") }}</p>
        <p>{{ $t("terms.title4_text3_2") }}</p>

        <br><br>
        <h4 class="blueTitle">{{ $t("terms.title5") }}</h4><br>
        <h4>{{ $t("terms.title5_subtitle1") }}</h4>
        <p>{{ $t("terms.title5_text1_1") }}</p>
        <p>{{ $t("terms.title5_text1_2") }}</p>

        <h4>{{ $t("terms.title5_subtitle2") }}</h4>
        <p>{{ $t("terms.title5_text2_1") }}</p>
        <p>{{ $t("terms.title5_text2_2") }}</p>
        <p>{{ $t("terms.title5_text2_3") }}</p>
        <p>{{ $t("terms.title5_text2_4") }}</p>
        <p>{{ $t("terms.title5_text2_5") }}</p>
        <p>{{ $t("terms.title5_text2_6") }}</p>
        <p>{{ $t("terms.title5_text2_7") }}</p>
        <p v-html="$t('terms.title5_text2_8')"></p>
        <p>{{ $t("terms.title5_text2_9") }}</p>

        <br><br>
        <h4 class="blueTitle">{{ $t("terms.title6") }}</h4><br>
        <h4>{{ $t("terms.title6_subtitle1") }}</h4>
        <p>{{ $t("terms.title6_text1_1") }}</p>
        <p>{{ $t("terms.title6_text1_2") }}</p>

        <h4>{{ $t("terms.title6_subtitle2") }}</h4>
        <p>{{ $t("terms.title6_text2_1") }}</p>
        <p v-html="$t('terms.title6_text2_2')"></p>

        <h4>{{ $t("terms.title6_subtitle3") }}</h4>
        <p>{{ $t("terms.title6_text3_1") }}</p>

        <h4>{{ $t("terms.title6_subtitle4") }}</h4>
        <p>{{ $t("terms.title6_text4_1") }}</p>
        <p>{{ $t("terms.title6_text4_2") }}</p>

        <h4>{{ $t("terms.title6_subtitle5") }}</h4>
        <p v-html="$t('terms.title6_text5_1')"></p>

        <br><br>
        <h4 class="blueTitle">{{ $t("terms.title7") }}</h4><br>
        <h4>{{ $t("terms.title7_subtitle1") }}</h4>
        <p>{{ $t("terms.title7_text1_1") }}</p>
        <p>{{ $t("terms.title7_text1_2") }}</p>
        <p>{{ $t("terms.title7_text1_3") }}</p>
        <p>{{ $t("terms.title7_text1_4") }}</p>
        <p v-html="$t('terms.title7_text1_5')"></p>


      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  computed: {},
  components: {
  },
  mounted() {},
  methods: {},
};
</script>


<style>
</style>